var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33881 3.4732L14.8291 9.57476C14.9383 9.68644 15 9.84083 15 10.0022C15 10.1636 14.9383 10.318 14.8291 10.4297L8.33881 16.5284C8.23478 16.627 8.09776 16.6763 7.95907 16.6651C7.82037 16.6539 7.69186 16.5831 7.60292 16.469L6.7926 15.4413C6.60428 15.2029 6.62999 14.8473 6.85037 14.6425L11.77 10.1069C11.7987 10.0805 11.8153 10.0421 11.8153 10.0017C11.8153 9.96121 11.7987 9.92277 11.77 9.89639L6.84985 5.35911C6.74442 5.26061 6.6797 5.12166 6.66978 4.97248C6.6573 4.82305 6.70198 4.67459 6.79364 4.56086L7.60292 3.53264C7.6917 3.41785 7.82037 3.34647 7.95941 3.33488C8.09828 3.32365 8.2354 3.37364 8.33881 3.4732Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.607e5fce.svg";
export { ForwardRef as ReactComponent };